module.exports = __webpack_public_path__ + "static/lageplan_wanderfahrradwege_mini-bfa3ab227486ec9dcd491a930d844c40.png";